import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import CardProjet from './cardProjet'; // Import du nouveau composant pour les projets
import 'bootstrap-icons/font/bootstrap-icons.css';

const ClubInfo = () => {
  const { id } = useParams(); // Récupération de l'ID du club
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]); // État pour stocker les projets
  const [members, setMembers] = useState([]); // État pour stocker les membres

  useEffect(() => {
    const fetchClubDetails = async () => {
      try {
        const response = await axios.get(`https://www.clublfit.org/api/clubs/${id}`);
        setClub(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchClubProjects = async () => {
      try {
        const response = await axios.get(`https://www.clublfit.org/api/clubs/projets/${id}`);
        const projectsWithImages = response.data.map((project) => {
          if (project.Url_IMG_Projet) {
            return { ...project, imageUrl: project.Url_IMG_Projet };
          } else if (project.Photo_Projet && project.Photo_Projet.data) {
            const blob = new Blob([new Uint8Array(project.Photo_Projet.data)], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);
            return { ...project, imageUrl };
          } else {
            console.warn(`Aucune image disponible pour le projet ID: ${project.Id_Projet}`);
            return { ...project, imageUrl: null };
          }
        });
        setProjects(projectsWithImages);
      } catch (err) {
        setError(err.message);
      }
    };

    const fetchClubMembres = async () => {
      try {
        const response = await axios.get(`https://www.clublfit.org/api/clubs/Membres/${id}`);
        setMembers(response.data); 
      } catch (err) {
        setError(err.message);
      }
    };

    fetchClubMembres();
    fetchClubDetails();
    fetchClubProjects(); 
  }, [id]);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>Erreur: {error}</div>;
  }

  return (
    <div className="container">
      <div className="col-lg-12 col-md-6 mb-30 text-center mx-auto">
        <h2>{club.Nom_Club}</h2>
        <p>{club.Description_Club}</p>

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-8">
              <div className="section-title text-center">
                <h2><span>Projets</span></h2>
              </div>

              {/* Utilisation du nouveau composant CardProjet */}
              <CardProjet projects={projects} />
            </div>

            <div className="col-12 col-md-4 col-lg-4">
              <div className="section-title text-center">
                <h2><span>Membres</span></h2>
              </div>

              <div className="member-list row">
                {["Président", "Trésorier", "Secrétaire"].map(role => (
                  members.filter(member => member.Role === role).map(member => (
                    <div key={member.id} className="member-card col-12 col-sm-6 col-md-4 mb-3">
                      <h5 className="RolePresident">{member.Role}</h5>
                      <img src={member.photo || "https://static.vecteezy.com/system/resources/previews/036/627/762/original/ai-generated-cute-chibi-fox-cartoon-fox-character-free-png.png"} alt={`${member.Nom_Eleves} ${member.Prenom_Eleves}`} />
                      <div className="member-info">
                        <h5>{member.Nom_Eleves} {member.Prenom_Eleves}</h5>
                        <h6>{member.Classe_Eleves}</h6>
                      </div>
                    </div>
                  ))
                ))}

                {members.filter(member => !["Président", "Trésorier", "Secrétaire"].includes(member.Role)).map(member => (
                  <div key={member.id} className="member-card col-12 col-sm-6 col-md-4 mb-3">
                    <h5 className="RoleMembre">{member.Role}</h5>
                    <img src={member.photo || "https://thumb.ac-illust.com/5b/5b5293d2d9ff39992a9a392c669ebc44_t.jpeg"} alt={`${member.Nom_Eleves} ${member.Prenom_Eleves}`} />
                    <div className="member-info">
                      <h5>{member.Nom_Eleves} {member.Prenom_Eleves}</h5>
                      <h6>{member.Classe_Eleves}</h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubInfo;